import React from "react";
import "../../App.css";
import { TabTitle } from "../../utils/GeneralFunctions";

export default function Products() {
  TabTitle("Products-TRVLR");
  return <h1 className="products">PRODUCTS</h1>;
}
